import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { fr } from '@/i18n/fr'
import { useMe } from '@/api/hooks'

export function ProtectedRoute() {
  const { data: user, isPending } = useMe()
  const location = useLocation()

  if (isPending) {
    return <p className="p-6 text-stone-500">{fr.common.loading}</p>
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}

export function PublicOnlyRoute() {
  const { data: user, isPending } = useMe()

  if (isPending) {
    return <p className="p-6 text-stone-500">{fr.common.loading}</p>
  }

  if (user) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
